import Home from "layouts/LandingPage/Home";
import app from "./app.css";
import * as React from "react";
import { useState, useEffect, useMemo, createContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import routes from "routes";
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";
import brandWhite from "assets/images/logo.ico";
import brandDark from "assets/images/logo-ct-dark.png";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import UsersApi from "Classes/API/UsersApi";
import SearchStringOrIntReq from "Classes/Models/Requests/SearchStringOrIntReq";
import ConnectionService from "./Classes/ConnectionService";
import toast, { Toaster } from "react-hot-toast";
import BrandingTheme from "BrandingTheme";
import en from "./en.json";
import ar from "./ar.json";
import { jwtDecode } from "jwt-decode";
import CreateUserReq from "Classes/Models/Requests/Users/CreateUserReq";
import TenantManager from "Classes/API/TenantManager";
export const UserContext = createContext();
export const ConnectionContext = createContext();
export const LanguageContext = createContext();
import { useNavigate } from "react-router-dom";
import PrivacyPolicy from "layouts/LandingPage/PrivacyPolicy";

export default function App() {
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const [language, setLanguage] = useState("en");
  const translations = language === "en" ? en : ar;

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      setLanguage(storedLanguage);
    }
  }, []);
  const switchLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
  };

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const [UserData, SetUserData] = useState({});
  const [MasterLoaded, SetMasterLoaded] = useState(false);
  const [ConnectionServiceObj, SetConnectionServiceObj] = useState();
  const auth = getAuth();

  const [user, loading, error] = useAuthState(auth);

  useEffect(() => {
    const fetchUser = async () => {
      if (!loading) {
        if (user) {
          const decoded = jwtDecode(user.accessToken);
          let req = new SearchStringOrIntReq();
          req.SearchString = user.uid;
          const res = await UsersApi.GetUserByFirebaseId(req);

          let fetchedUser = res.data;

          // && decoded iuser is superadmin
          if (!fetchedUser && decoded?.tenant === "superadmin") {
            // Show confirmation dialog instead of automatically creating
            const shouldCreateAccount = window.confirm(
              "No account found for this tenant. Would you like to create a superadmin account?\n\n" +
                "Click OK to create account or Cancel to refresh and check again."
            );

            if (shouldCreateAccount) {
              let createReq = new CreateUserReq();
              createReq.FirebaseId = decoded?.user_id;
              createReq.Number = 0;
              createReq.Address = "";
              createReq.Name = decoded?.email;
              createReq.Gender = "";
              createReq.Age = 0;
              createReq.FoundBy = 0;
              createReq.Nationality = "Egyptian";
              createReq.UserType = "Admin";
              createReq.isActivated = true;
              createReq.isSoftDeleted = false;
              createReq.isAssessmentTherapist = false;
              createReq.Email = decoded?.email;
              createReq.NationalId = "";
              createReq.RelativeNumber = "";
              createReq.AccreditedPartners = "";
              createReq.ChronicDiseases = "";
              createReq.Sensitivity = "";
              createReq.Medications = "";
              createReq.isSuperAdmin = true;

              try {
                var createRes = await UsersApi.CreateUser(createReq);
                if (createRes.status == "Success") {
                  fetchedUser = createRes.data;
                }
              } catch (error) {
                console.error("Account creation failed:", error);
                // Optionally show error message to user
                window.alert("Account creation failed. Please try again.");
                return; // Exit without setting user data
              }
            } else {
              // User chose to refresh instead of create account
              window.location.reload();
              return; // Exit as we're refreshing
            }
          }

          // fetchedUser.tenant = decodedToken.tenant;

          SetUserData(fetchedUser);
        } else {
          SetUserData("NotSignedIn");
        }
      } else {
        SetUserData("NotLoaded");
      }
    };

    fetchUser();
  }, [loading, user]);

  //console.log({ UserData, user });

  useEffect(() => {
    if (loading) {
      SetMasterLoaded(false);
      return;
    } else {
      if (UserData != "NotLoaded") {
        if (user && !UserData) {
          SetMasterLoaded(false);
          return;
        }
        if (user && UserData) {
          SetMasterLoaded(true);

          return;
        } else if (!user && UserData == "NotSignedIn") {
          SetMasterLoaded(true);
          return;
        } else {
          SetMasterLoaded(false);
          return;
        }
      }
    }
  }, [loading, user, UserData]);

  useEffect(() => {
    if (typeof UserData == "object" && Object.keys(UserData).length > 0) {
      let connectionService = new ConnectionService(UserData);
      connectionService.StartConnection();
      SetConnectionServiceObj(connectionService);
    }
  }, [UserData]);

  useEffect(() => {
    return () => {
      if (ConnectionServiceObj) {
        ConnectionServiceObj.StopConnection();
      }
    };
  }, []);

  const getRoutes = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });
  };

  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );

  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  return pathname === "/home" ? (
    <Home />
  ) : pathname === "/privacy-policy" ? (
    <PrivacyPolicy />
  ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <UserContext.Provider value={UserData}>
        <ConnectionContext.Provider value={ConnectionServiceObj}>
          <LanguageContext.Provider value={{ language, translations, switchLanguage }}>
            <CssBaseline />
            {layout === "dashboard" && (
              <>
                <Sidenav
                  color={sidenavColor}
                  // brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
                  brand={brandDark}
                  brandName={translations.appTitle}
                  routes={routes}
                  onMouseEnter={handleOnMouseEnter}
                  onMouseLeave={handleOnMouseLeave}
                />

                {/* <Configurator />
          {configsButton} */}
              </>
            )}

            {layout === "vr" && <Configurator />}
            <Routes>
              {getRoutes(routes)}
              <Route path="*" element={<Navigate to="/home" />} />
            </Routes>
            <Toaster />
          </LanguageContext.Provider>
        </ConnectionContext.Provider>
      </UserContext.Provider>
    </ThemeProvider>
  );
}
